import React from "react";
import type {VoidFunctionComponent} from "react";
import {useSongResultsScrollableContentLogic} from "./SongResultsScrollableContent.logic";
import {SongsResultsRouter} from "../../../../modules/songs/results-router/SongsResultsRouter";

export interface ISongResultsScrollableContentProps {
  className?: string;
}

export const SongResultsScrollableContent: VoidFunctionComponent<ISongResultsScrollableContentProps> = ({className}) => {
  const {scrollableContentRef, onScrollHandler} = useSongResultsScrollableContentLogic();
  return (
    <main className={className} ref={scrollableContentRef} onScroll={onScrollHandler} >
      <SongsResultsRouter />
    </main>
  );
}

